import { configureStore } from "@reduxjs/toolkit";
import { api } from "./services/api";
import menuReducer from "./features/menu/menuSlice";
import quizReducer from "./features/quiz/quizSlice";
import { cartReducer } from "./features/cart/cartSlice";
import authReducer from "./features/auth/authSlice";
import howToBrewReducer from "./features/howToBrew/howToBrewSlice";
import { productsReducer } from "./features/products/productsSlice";
import { userReducer } from "./features/user/userSlice";
import { checkoutReducer } from "./features/checkout/checkoutSlice";
import { blogsReducer } from "./features/blogs/blogsSlice";
import brewingMethodsReducer from "./features/brewingMethods/brewingMethodsSlice";
import brandsReducer from "./features/brands/brandsSlice";
import locationsReducer from "./features/locations/locationSlice";

export const store = configureStore({
  reducer: {
    [api.reducerPath]: api.reducer,
    user: userReducer,
    auth: authReducer,
    menu: menuReducer,
    cart: cartReducer,
    quiz: quizReducer,
    howToBrew: howToBrewReducer,
    products: productsReducer,
    checkout: checkoutReducer,
    brewingMethods: brewingMethodsReducer,
    blogs: blogsReducer,
    brands: brandsReducer,
    locations: locationsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(api.middleware),
});
